// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f6-0";
export var actionModalContentContainer = "_f6-1";
export var createTagButton = "_f6-2";
export var footerContainer = "_f6-7";
export var fullWidthDivider = "_f6-3";
export var hasCreateTagButton = "_f6-4";
export var noCreateTagButton = "_f6-5";
export var tagsContainer = "_f6-6";
export var tagsModalContentContainer = "_f6-8";